<section class="possec3">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <app-cards-general-posgrados *ngIf='idSeccion' title='Cursos Abiertos, Jornadas y Extensión
' [id]='idSeccion'></app-cards-general-posgrados>
            </div>
        </div>
    </div>
</section>